<template>
  <div class="slot-panel" style="color:white">
    <div class="line">
      <span class="label" style="width: 90px;">宽:</span>
      <!-- <Input placeholder="宽" v-model="slotInfo.position.width" size="small" @on-change="save"></Input> -->
      <NumberUnitProp v-model="slotInfo.position.width" :units="units"></NumberUnitProp>
    </div>
    <div class="line">
      <span class="label" style="width: 90px;">高:</span>
      <!-- <Input placeholder="高" v-model="slotInfo.position.height" size="small" @on-change="save"></Input> -->
      <NumberUnitProp v-model="slotInfo.position.height" :units="units"></NumberUnitProp>
    </div>
    <div class="line">
      <span class="label" style="width: 90px;">禁止横向滚动:</span>
      <i-switch v-model="slotInfo.position.hideOverflowX" size='small'></i-switch>
    </div>
    <div class="line">
      <span class="label" style="width: 90px;">禁止纵向滚动:</span>
      <i-switch v-model="slotInfo.position.hideOverflowY" size='small'></i-switch>
    </div>
  </div>
</template>
<style lang="less">
    .slot-panel{
        .label{
            display: inline-block;
            width: 30px;
            margin-left: 5px;
        }
        .line{
            margin: 5px 0px;
        }
    }
</style>
<script>
import NumberUnitProp from "../common-prop-editor/number-unit-prop";
export default {
  props: ["slotInfo"],
  data() {
    return {
      units: [
                {
                  value: "px",
                  label: "像素"
                },
                {
                  value: "%",
                  label: "百分比"
                }
              ]
    }
  },
  components:{NumberUnitProp},

  methods: {
    save() {
      this.$emit("save");
    }
  }
};
</script>